import { Dashboard } from "components";

const Products = ({ data }) => {
  return (
    <Dashboard
      header={{
        icon: "product",
        title: "Produkty",
      }}
    >
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data.map(({ id, sku, name }) => (
              <tr key={id}>
                <td>
                  <a
                    className="text-link"
                    href={`/products/${id}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    [{sku}] {name}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default Products;
